import { HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { ColorCodedText } from '../../../../../components/ColorCodedText';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../components/TableContent';
import { FundsAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { AccordionButton } from '../../AccordionButton';
import { QuoteButton } from '../../QuoteButton';
import { IDynamicProductSearchItem } from '../_dynamic';

import { FundsSecondaryInfo } from './components/SecondaryInfo';
import { tableHead } from './constants';

const ProductSearchItem = ({
  item,
  product,
  quoteButtonInfoGetter,
}: IDynamicProductSearchItem<FundsAssetsQueryItem>) => {
  const hasQuoteButton = !!quoteButtonInfoGetter;

  const [isOpen, setIsOpen] = React.useState(false);

  const renderSecondaryInfo = () => {
    return <FundsSecondaryInfo product={item} />;
  };

  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent
      direction="column"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <HStack w="full" alignItems="center">
        <TableContentItemColumn flex={getFlex(0)}>
          <TableContentItemText>{item.productNameNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <TableContentItemText>{item.productTypeNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <TableContentItemText>{item.positionDateNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TableContentItemText>{item.valueNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <ColorCodedText text={item.variationNormalized} sign={item.variationType} />
        </TableContentItemColumn>
        {hasQuoteButton && (
          <TableContentItemColumn flex={getFlex(5)}>
            <HStack justifyContent="space-between" w="full">
              <QuoteButton {...quoteButtonInfoGetter(item)} />
              <AccordionButton isOpen={isOpen} setIsOpen={setIsOpen} />
            </HStack>
          </TableContentItemColumn>
        )}
      </HStack>
      {!!isOpen && renderSecondaryInfo()}
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
